import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Column } from '@simplywallst/ui-core';

export const NewsItemWrapper = styled(Column)`
  margin-bottom: ${({ theme }) => theme.x3space}rem;
  &:last-child {
    margin-bottom: 0;
  }
  ${media.lgUp`
    margin-bottom: 0;
  `}
`;
